import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-form-multi-select-search', 'MultiSelectSearch', MultiSelectSearch)

function MultiSelectSearch(component) {
  const multiHiddenInput = component.element.querySelector('.js-c-form-multi-select-search-input-hidden')
  const badgesContainer = component.element.querySelector('.c-badges-container')
  const badgeClasses = badgesContainer.dataset.badgeClasses
  const removeButtonClasses = badgesContainer.dataset.removeButtonClasses
  const singleSelectInput = component.element.querySelector('.js-c-form-select-search-input-hidden')

  component.useHandler(() => {
    singleSelectInput.addEventListener('change', handleSelectChange)
    badgesContainer.addEventListener('click', handleRemoveClick)

    return () => {
      singleSelectInput.removeEventListener('change', handleSelectChange)
      badgesContainer.removeEventListener('click', handleRemoveClick)
    }
  })

  // Creates a badge for (value, label), unless it's already present
  function addBadge(value, label) {
    if (!value) return

    // If we already have this value, do nothing
    if (badgesContainer.querySelector(`[data-value="${value}"]`)) return false

    const badge = document.createElement('span')
    const badgeId = `badge-${value}`
    badge.className = badgeClasses
    badge.textContent = label
    badge.id = badgeId

    const svgIcon = document.createElement('img')
    svgIcon.src = 'https://unpkg.com/lucide-static@0.471.0/icons/x.svg'
    svgIcon.width = 16
    svgIcon.height = 16

    const removeBtn = document.createElement('button')
    removeBtn.className = `js-c-form-multi-select-search-remove ${removeButtonClasses}`
    removeBtn.type = 'button'
    removeBtn.dataset.value = value
    removeBtn.appendChild(svgIcon)
    removeBtn.setAttribute('aria-describedby', badgeId)
    removeBtn.setAttribute('aria-label', `Remove ${label}`)
    badge.appendChild(removeBtn)
    badgesContainer.appendChild(badge)

    updateMultiHiddenInput()
    return true
  }

  function handleRemoveClick(event) {
    const removeButton = event.target.closest('.js-c-form-multi-select-search-remove')
    if (!removeButton || !badgesContainer.contains(removeButton)) return

    removeButton.closest('span').remove()
    updateMultiHiddenInput()
  }

  function updateMultiHiddenInput() {
    const previousValues = Array.from(multiHiddenInput.selectedOptions).map(option => option.value)
    const values = Array.from(badgesContainer.querySelectorAll('.js-c-form-multi-select-search-remove')).map(
      btn => btn.dataset.value
    )

    multiHiddenInput.innerHTML = ''
    values.forEach(value => {
      const option = document.createElement('option')
      option.value = value
      option.selected = true
      multiHiddenInput.appendChild(option)
    })

    if (values.join(',') !== previousValues.join(',')) {
      multiHiddenInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  // When user picks an item in select_search, we get singleSelectInput.value
  // and singleSelectInput.dataset.text to create the badge
  // we also clear the selectSearch
  function handleSelectChange() {
    const val = singleSelectInput.value
    const text = singleSelectInput.dataset.text
    if (val) addBadge(val, text || val)

    // Clear the singleSelect so user can pick again
    singleSelectInput.value = ''
    singleSelectInput.dataset.text = ''

    // Also clear the visible input in the select_search
    const visibleInput = component.element.querySelector('.js-c-form-select-search-input')
    if (visibleInput) visibleInput.value = ''
  }
}

export function clearBadgesAndUpdateParamsFor(inputElement, newParams = {}) {
  if (!inputElement) return
  const multiSelectEl = inputElement.closest('.js-c-form-multi-select-search')
  if (!multiSelectEl) return

  const badgesContainer = multiSelectEl.querySelector('.c-badges-container')
  const multiHiddenInput = multiSelectEl.querySelector('.js-c-form-multi-select-search-input-hidden')
  const selectSearchEl = multiSelectEl.querySelector('.c-form-select-search')

  // Clear the badges and reset the hidden input
  if (badgesContainer) badgesContainer.innerHTML = ''
  if (multiHiddenInput) {
    multiHiddenInput.innerHTML = ''
    multiHiddenInput.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // Update the query params with the new or other params passed
  if (selectSearchEl) {
    const currentParams = JSON.parse(selectSearchEl.dataset.queryParams || '{}')
    const updatedParams = { ...currentParams, ...newParams, ts: Date.now() } // Adding a timestamp to force reload
    selectSearchEl.dataset.queryParams = JSON.stringify(updatedParams)

    // Trigger a reload event for the select_search component
    selectSearchEl.dispatchEvent(new Event('reload', { bubbles: true }))
  }
}
